export const ContentfulTypes = {
    LP_ROOT_CONFIG: 'LPRootConfig'
};
